export default {
  set: (name, value, hours) => {
    let d = new Date();
    if (!hours) hours = 24;
    d.setTime(d.getTime() + 60 * 60 * 1000 * hours);
    window.document.cookie = `${name}=${value};path=/;expires=${d.toGMTString()}`;
  },
  get: (name) => {
    var v = window.document.cookie.match(`(^|;)?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
  },
  delete: (name) => {
    this.set(name, '', -1);
  }
};



// WEBPACK FOOTER //
// ./src/utils/cookiesHelper.js